onReady(($) => {
    $('.pc-lifecycle.module')
        .each((index, module) => {
            $('.pc-products span', module)
                .each((i, link) => {
                    $(".".concat(link.dataset["class"]), module)
                        .on('click', function () {
                            window.location = link.dataset.url;
                        });
                    $(".".concat(link.dataset["class"]), module)
                        .addClass('hover');
                });
        });
});
